/**
 * İletişim bilgisi koruması (e-posta / telefon hasatına karşı).
 *
 * Sorun: site prerender ediliyor (scripts/prerender.mjs). Bu yüzden footer ve
 * iletişim sayfasındaki e-posta ve telefon, 98 statik HTML dosyasında düz metin
 * olarak duruyordu. Spam botlarının büyük çoğunluğu JavaScript çalıştırmaz,
 * sadece ham HTML üzerinde regex tarar. Düz metin olduğu sürece bu adresler
 * kolayca toplanır.
 *
 * Çözüm iki katmanlı:
 *  1) Kaynak koddaki sabitler burada kodlanmış tutulur (bundle içinde düz
 *     "canozen@csg.com.tr" dizgesi aranarak bulunamaz).
 *  2) Değer yalnızca tarayıcıda, mount sonrasında DOM'a yazılır. Bkz.
 *     components/ProtectedContact.tsx. Prerender çıktısında yer almaz.
 *
 * Bu yöntem kararlı bir saldırganı durdurmaz, hiçbir yöntem durdurmaz. Amaç
 * otomatik toplayıcıların maliyetini, artık bu siteyi taramaya değmeyecek
 * kadar yükseltmek.
 */

/** Kodlanmış değeri çözer. encodeContact'ın tersi. */
export function decodeContact(encoded: string): string {
  if (!encoded) return "";
  try {
    // atob → ters çevir. Tarayıcı ortamı varsayılır.
    return atob(encoded).split("").reverse().join("");
  } catch {
    return "";
  }
}

/**
 * Yeni bir değer kodlamak için yardımcı. Üretimde çağrılmaz, tarayıcı
 * konsolunda veya testte kullanılır.
 */
export function encodeContact(plain: string): string {
  return btoa(plain.split("").reverse().join(""));
}

/** Kodlanmış iletişim sabitleri. Düzenlemek için encodeContact kullanın. */
export const CONTACT = {
  istanbulEmail: "cnQubW9jLmdzY0BuZXpvbmFj",
  budapestEmail: "bW9jLjEwMW1laUBuZXpvbmFj",
  istanbulPhone: "NzcwNSAyODIgMjM1IDA5Kw==",
  budapestPhone: "ODgxOCA3MTYgMDcgNjMr",
  /** tel: bağlantısı için boşluksuz biçim */
  istanbulPhoneRaw: "NzcwNTI4MjIzNTA5Kw==",
  /** wa.me için ülke kodlu, artısız biçim: 905322825077 */
  whatsappNumber: "NzcwNTI4MjIzNTA5",
} as const;

/** Görsel yer tutucu. Hidrasyon öncesi ve JS kapalıyken gösterilir. */
export function maskFor(kind: "email" | "phone"): string {
  return kind === "email" ? "•••••••@•••••••" : "+90 ••• ••• ••••";
}
